import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class HomeEventIdResolver implements Resolve<number> {
  constructor() {}

  resolve(
    activatedRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    const urlSliceWithId = state.url.split('schedule/').reverse()[0];
    const eventId = Number(urlSliceWithId.split('/')[0]);

    return eventId;
  }
}
